import { h, Host } from "@stencil/core";
/**
 * @slot (default) - insert the content of the various form step, only supported
 * form elements of the ux-form component will be validated by it.
 */
let formStepCounter = 0;
export class FormStep {
    baseClass = "ux-form-step";
    formStepTabId = `ux-form-step-tab-${formStepCounter++}`;
    render() {
        return (h(Host, { key: '5d7155c94a751f48c283cf6bc8636d24d8d8fa71', class: this.baseClass }, h("ux-tab", { key: '7e57620650fd29dd57d296bca7792314cd97856c', "tab-id": this.formStepTabId, name: this.formStepTabId }, h("slot", { key: 'f494661edd5a730baba90e6786a50a3663120a29' }))));
    }
    static get is() { return "ux-form-step"; }
    static get originalStyleUrls() {
        return {
            "$": ["form-step.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form-step.css"]
        };
    }
}
//# sourceMappingURL=form-step.js.map
